import CanonicalList from './CanonicalList';

export default CanonicalList;
